import request from "@/utils/request";
const baseApi = "https://ai.cdhcgg.cn/api";

// 获取教学课本列表
export function getBookList(params) {
  return request.get("/app/bsBook/v1/page", params, { loading: true });
}

// 获取教学课本详情
export function getBookDetail(id) {
  return request.get("/app/bsBook/arti/" + id, {}, { loading: true });
}

// 获取教学课本展示
export function getBookAnalysis(id) {
  return request.get("/app/bsBook/analysis/" + id, {}, { loading: true });
}

// 获取作训练秒评考试结果
export function getQuestionResult(id) {
  return request.get(
    "/app/bsQuestion/arti/test/detail/" + id,
    {},
    { loading: true }
  );
}

// 获取所有训练秒评题目
export function getQuestionList(id) {
  return request.get(
    "/app/bsQuestion/arti/test/question/" + id,
    {},
    { loading: true }
  );
}

// 获取训练秒评题目最高得分答题结果
export function getQuestionAnswer(params) {
  return request.get(
    "/app/bsQuestion/arti/test/question/maxscore/result",
    params,
    { loading: true }
  );
}

// 提交训练秒评
export function submitQuestion(data) {
  return request.post("/app/bsQuestion/arti/test/submit", data, {
    loading: true
  });
}

// 作文记录
export function getHistory(data) {
  return request.post("/app/bsArti/page", data, {
    loading: true
  });
}

// 第一版作文
export function getCorrecting(id) {
  return request.get("/app/bsArti/artiCorrecting/" + id, {}, { loading: true });
}

// 重写版作文
export function getRewrite(id) {
  return request.get("/app/bsArti/artiRewrite/" + id, {}, { loading: true });
}

// 润色版作文
export function getPolishing(id) {
  return request.get("/app/bsArti/artiPolishing/" + id, {}, { loading: true });
}

// ai调用结果保存
export function saveSreamResult(data) {
  return request.post("/stream/ai/return/result", data, {
    loading: true
  });
}

// 作文常规评阅流式响应
export function compEvalStreaming(data) {
  return request.post("/stream/ai/compEvalStreaming", data, {
    loading: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}

// 范文解析流式响应
export function compModelAnalysisStreaming(data) {
  return request.post("/stream/ai/compModelAnalysisStreaming", data, {
    loading: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}

// 作文指导流式响应
export function compGuidanceStreaming(data) {
  return request.post("/stream/ai/compGuidanceStreaming", data, {
    loading: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}

// 作文润色流式响应
export function compPolishingStreaming(data) {
  return request.post("/stream/ai/compPolishingStreaming", data, {
    loading: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}

// 作文素材流式输出
export function compMaterialStreaming(data) {
  return request.post("/stream/ai/compMaterialStreaming", data, {
    loading: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}

// 真题列表
export function getExam(data) {
  return request.post("/app/bsArtiExam/page", data, {
    loading: true
  });
}

// 真题详情
export function getExamDetail(id) {
  return request.get("/app/bsArtiExam/" + id, {}, { loading: true });
}

// 真题作文指导
export function getExamGuide(id) {
  return request.post("/app/bsArtiExam/guidance/" + id, {}, { loading: true });
}

// 作文教学评阅流式输出
export function compTeachEvalStreaming(data) {
  return request.post("/stream/ai/compTeachEvalStreaming", data, {
    loading: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}

// 作文考试评阅流式输出
export function compExamEvalStreaming(data) {
  return request.post("/stream/ai/compExamEvalStreaming", data, {
    loading: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}

// 作文重写流式响应
export function compRewiredEvalStreaming(data) {
  return request.post("/stream/ai/compRewiredEvalStreaming", data, {
    loading: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}

// 批量删除作文记录
export function delArti(data) {
  return request.post("/app/bsArti/batchDelete", data, {
    loading: true
  });
}

// 检查今天ai调用是否超过提醒阀值
export function checkAiCall(data) {
  return request.get(
    "/stream/ai/V1/check/today/ai/call",
    {},
    {
      loading: true
    }
  );
}

// 个人素材库列表
export function getMaterial(data) {
  return request.post("/app/bsMaterial/person/page", data, {
    loading: true
  });
}

// 删除个人素材
export function materialDel(data) {
  return request.delete(
    "/app/bsMaterial/manage",
    { data },
    {
      loading: true
    }
  );
}

// 生成个人素材
export function materialAdd(data) {
  return request.post("/app/bsMaterial/addPerson", data, {
    loading: true
  });
}

// 图片批改
export function compPictureStreaming(data) {
  return request.post("/streamaitwo/comp_picture", data, {
    loading: true,
    timeout: 1800000
  });
}

// 阿里语音-直接返回OSS语音访问地址
export function getVoiceDataOss(data) {
  return request.post("/alibabavoice/getVoiceDataOss", data, {
    loading: true
  });
}

// 公共素材库列表
export function getPubMaterial(data) {
  return request.post("/app/bsMaterial/pub/page", data, {
    loading: true
  });
}

// 公共素材-年级列表
export function materialGrade(data) {
  return request.get("/app/bsMaterial/gradelist", data, {
    loading: true
  });
}

// 公共素材-单元列表
export function materialUnit(data) {
  return request.get(
    "/app/bsMaterial/unitList/" + data,
    {},
    {
      loading: true
    }
  );
}

// ai返回内容收藏
export function materialCollectAi(data) {
  return request.post("/app/bsMaterial/collectAi", data, {
    loading: true
  });
}

// 解除收藏
export function materialUnCollect(data) {
  return request.get(
    "/app/bsMaterial/uncollect/" + data,
    {},
    {
      loading: true
    }
  );
}

// 收藏公共素材
export function materialCollect(data) {
  return request.get(
    "/app/bsMaterial/collect/" + data,
    {},
    {
      loading: true
    }
  );
}

// 素材详情
export function getMaterialDetail(data) {
  let url =
    data.type == 1
      ? `/app/bsMaterial/personal/detail/${data.id}`
      : `/app/bsMaterial/detail/${data.id}`;
  return request.get(
    url,
    {},
    {
      loading: true
    }
  );
}

// html文本转pdf文件流
export function html2Pdf(data) {
  return request.post("/pdf/html2PdfOss", data, {
    loading: true
  });
}

export const compEvalStreamingV1 = baseApi + "/stream/ai/V1/compEvalStreaming";
export const compTeachEvalStreamingV1 =
  baseApi + "/stream/ai/V1/compTeachEvalStreaming";
export const compExamEvalStreamingV1 =
  baseApi + "/stream/ai/V1/compExamEvalStreaming";
export const compGuidanceStreamingV1 =
  baseApi + "/stream/ai/V1/compGuidanceStreaming";
export const compModelAnalysisStreamingV1 =
  baseApi + "/stream/ai/V1/compModelAnalysisStreaming";
export const compPolishingStreamingV1 =
  baseApi + "/stream/ai/V1/compPolishingStreaming";
export const compRewiredEvalStreamingV1 =
  baseApi + "/stream/ai/V1/compRewiredEvalStreaming";
export const compMaterialStreamingV1 =
  baseApi + "/stream/ai/V1/compMaterialStreaming";

export const compEvalStreamingV2 = baseApi + "/streamaitwo/comp_eval_streaming";
export const compTeachEvalStreamingV2 =
  baseApi + "/streamaitwo/comp_teach_eval_streaming";
export const compExamEvalStreamingV2 =
  baseApi + "/streamaitwo/comp_exam_eval_streaming";
export const compPolishingStreamingV2 =
  baseApi + "/streamaitwo/comp_polishing_streaming";
export const compRewiredEvalStreamingV2 =
  baseApi + "/streamaitwo/compRewiredEvalStreaming";
export const compMaterialStreamingV2 =
  baseApi + "/streamaitwo/synchronous/comp_material_streaming";
